import { TTimePage } from '../../types/messages';

/** Конвертирует дату в страницу времени [год, месяц, день]. */
export function getTimePage(dateOrString: Date | string | null | undefined): TTimePage {
  const date = dateOrString ? (typeof dateOrString === 'string' ? new Date(dateOrString) : dateOrString) : null;

  return date ? [date.getFullYear(), date.getMonth(), date.getDate()] : ([] as unknown as TTimePage);
}

/** Формирует ключ страницы времени. */
export function getTimePageKey(timePage: TTimePage): string {
  return `${timePage[0]}/${timePage[1]}/${timePage[2]}`;
}
